import React from 'react'
import { Helmet } from 'react-helmet'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { history } from 'index'
import Footer from 'gl-react-components/src/components/commonui/Footer/Footer'

const mapStateToProps = ({ user, dispatch }) => ({
  dispatch,
  loading: user.loading,
})

const SystemFooter = () => {
  const handlePrivacyPolicy = e => {
    e.preventDefault()
    history.push('/auth/privacy-policy')
  }

  const handleTermsAndServices = e => {
    e.preventDefault()
    history.push('/auth/terms-of-services')
  }

  return (
    <div>
      <Helmet title="Footer" />
      <Footer
        copyRights="@2020 Pay Perform Limited."
        handlePrivacyPolicy={handlePrivacyPolicy}
        handleTermsAndServices={handleTermsAndServices}
      />
    </div>
  )
}

export default withRouter(connect(mapStateToProps)(SystemFooter))
